import React, { memo, useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import styles from './index.less';
import 'swiper/swiper.less';
import noneimg from '@/assets/imgs/placeholderimg.png';
import { TLang } from '@/utils/lang';
import { getQueryString } from '@/utils';
interface IProps {
  data: Array<any>;
  initIndex: number;
  movieCount: number;
  callBack: (i: number) => void;
}
const DfSwiper = (props: IProps) => {
  const { data = [], initIndex, movieCount, callBack } = props;

  const [ref, setRef] = useState<any>(null);
  useEffect(() => {
    if (ref && initIndex) {
      ref.slideTo(initIndex);
    }
  }, [ref, initIndex]);
  useEffect(() => {
    const currentitem = data[initIndex];
    // fix: 初始index为0 不请求排期的问题.
    if (initIndex === 0 && movieCount<=1) {
      callBack && callBack(initIndex);
    }else if(currentitem?.id == getQueryString('mid')){
      callBack && callBack(initIndex);
    }
  }, []);
  return (
    <Swiper
      slidesPerView={2.6}
      freeMode={false}
      onSlideChangeTransitionEnd={(sp) => {
        callBack && callBack(sp.activeIndex);
      }}
      onSwiper={(swiper) => setRef(swiper)}
      centeredSlides
      initialSlide={initIndex}
      slideToClickedSlide
    >
      {data.map((item) => (
        <SwiperSlide key={item.id} className={styles['imgwrapper']}>
          {({ isActive }) => (
            <div
              className={`${styles['swrapper']} ${
                isActive ? styles['swrapper-active'] : styles['swrapper-normal']
              }`}
            >
              <img src={item.logo || noneimg} alt="logo" />
              {Array.isArray(item?.discountShowDates) &&  item?.discountShowDates.length > 0 ? <span className={styles.discount}>{TLang('折', 'home', false, false, null)}</span> : null}
            </div>
          )}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default memo(DfSwiper);
